package one.healthium.ui.common.message

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import kotlinx.coroutines.sync.Semaphore
import loco.GENERAL_OK
import one.healthium.loco.resolve
import one.healthium.ui.compose.components.AppAlertDialog
import org.jetbrains.compose.resources.stringResource

@Composable
fun AlertUiMessageHandler(uiMessageManager: UiMessageManager, onMessageHandled: (() -> Unit)? = null) {
    val message by uiMessageManager.latestMessage.collectAsState(null)
    var showDialogPayload by remember { mutableStateOf<UiMessage?>(null) }
    val semaphore = remember { Semaphore(1) }

    LaunchedEffect(message) {
        val currentMessage = message
        if (currentMessage != null) {
            semaphore.acquire()
            showDialogPayload = currentMessage
        }
    }

    fun dismissDialog() {
        showDialogPayload?.let { uiMessageManager.consume(it) }
        showDialogPayload = null
        semaphore.release()
    }

    val dialogPayload = showDialogPayload
    if (dialogPayload != null) {
        AppAlertDialog(
            onDismissRequest = { dismissDialog() },
            text = dialogPayload.message.resolve(),
            positiveButton = stringResource(loco.Res.string.GENERAL_OK),
            onPositiveClick = { onMessageHandled?.invoke() }
        )
    }
}